import { render, staticRenderFns } from "./bdproduct3.vue?vue&type=template&id=51a1fc0a&scoped=true"
import script from "./bdproduct3.vue?vue&type=script&lang=js"
export * from "./bdproduct3.vue?vue&type=script&lang=js"
import style0 from "./bdproduct3.vue?vue&type=style&index=0&id=51a1fc0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a1fc0a",
  null
  
)

export default component.exports